// app/index.tsx - Application entry point
// This file initializes providers and renders the app

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { router } from './providers'
import { AuthBootstrap, CatalogFreshnessBootstrap } from '@/features/auth'
import { SupportButton } from '@/shared/ui'
import { queryClient } from '@/shared/api'
import './styles/index.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthBootstrap />
      <CatalogFreshnessBootstrap />
      <RouterProvider router={router} />
      <SupportButton />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
)
